import { Stack, Typography, FormGroup, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import { ScheduleQuarter, ScheduleQuarterMode } from "../../../../../types/actionModule/schedulingStrategy/schedulingStrategyType";
import { ScheduleMonthsDefinitionEditorProps, ScheduleMonthsDefinitionEditor } from "./ScheduleMonthsDefinitionEditor";
import { ScheduleWeeksDefinitionEditorProps } from "./ScheduleWeeksDefinitionEditor";
import { useTranslation } from "react-i18next";

export interface ScheduleQuarterDefinitionProps extends ScheduleWeeksDefinitionEditorProps, ScheduleMonthsDefinitionEditorProps {
    quarterModel: ScheduleQuarter;
    onUpdateQuarterModel: (value: ScheduleQuarter) => void;
}

export function ScheduleQuarterDefinitionEditor(props: ScheduleQuarterDefinitionProps) {
    const { t } = useTranslation();

    return <Stack>
        <Typography variant="subtitle2">{t("actionModules.schedulingStrategy.scheduleDefinition.quarter.title")}</Typography>
        <Typography variant="caption">{t("actionModules.schedulingStrategy.scheduleDefinition.quarter.description")}</Typography>
        <FormGroup sx={{ flexDirection: "row", gap: 2, pt: 1 }}>
            <FormControl sx={{ minWidth: 250, flex: 1 }}>
                <InputLabel>{t("actionModules.schedulingStrategy.scheduleDefinition.quarter.scheduleMode.name")}</InputLabel>
                <Select
                    value={props.quarterModel.mode}
                    size="small"
                    fullWidth
                    label={t("actionModules.schedulingStrategy.scheduleDefinition.quarter.scheduleMode.name")}
                    onChange={(v) => props.onUpdateQuarterModel({
                        ...props.quarterModel,
                        mode: v.target.value as ScheduleQuarterMode,
                    })}
                >
                    <MenuItem value={ScheduleQuarterMode.None}>{t("actionModules.schedulingStrategy.scheduleDefinition.quarter.scheduleMode.none")}</MenuItem>
                    <MenuItem value={ScheduleQuarterMode.Repeat}>{t("actionModules.schedulingStrategy.scheduleDefinition.quarter.scheduleMode.repeat")}</MenuItem>
                    <MenuItem value={ScheduleQuarterMode.Skip}>{t("actionModules.schedulingStrategy.scheduleDefinition.quarter.scheduleMode.skip")}</MenuItem>
                </Select>
            </FormControl>
            {
                props.quarterModel.mode === ScheduleQuarterMode.Skip &&
                <TextField
                    value={props.quarterModel.value}
                    type="number"
                    onChange={(e) => props.onUpdateQuarterModel({
                        ...props.quarterModel,
                        value: Number(e.target.value)
                    })}
                    size="small"
                    sx={{ minWidth: 100, flex: 1 }}
                    label={t("actionModules.schedulingStrategy.scheduleDefinition.quarter.scheduleMode.value")} />
            }
        </FormGroup>
        <TextField
            value={props.quarterModel.monthOffsetInsideQuarter}
            type="number"
            onChange={(e) => props.onUpdateQuarterModel({
                ...props.quarterModel,
                monthOffsetInsideQuarter: Number(e.target.value)
            })}
            size="small"
            sx={{ minWidth: 100, flex: 1, mt: 1 }}
            label={t("actionModules.schedulingStrategy.scheduleDefinition.quarter.offset")} />

        <ScheduleMonthsDefinitionEditor
            {...props}
        />
    </Stack>
}
